import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

type Language = 'en' | 'zh' | 'ru' | 'fr' | 'de' | 'nl' | 'ms';

const languageNames: Record<Language, string> = {
  en: 'English',
  zh: '中文',
  ru: 'Русский',
  fr: 'Français',
  de: 'Deutsch',
  nl: 'Nederlands',
  ms: 'Bahasa Melayu'
};

export const LanguageSwitch: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-white hover:text-gray-200 transition-colors"
        aria-label="Switch Language"
      >
        <Globe className="w-5 h-5" />
        <span>{languageNames[language]}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-xl z-50">
          {(Object.entries(languageNames) as [Language, string][]).map(([code, name]) => (
            <button
              key={code}
              onClick={() => {
                setLanguage(code);
                setIsOpen(false);
              }}
              className={`block w-full text-left px-4 py-2 text-sm ${
                language === code
                  ? 'bg-blue-500 text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}; 